import imageField from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

const textCardFields = [
  {
    name: 'headingTag',
    type: 'string',
    enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    defaultValue: 'h3',
    helperText: 'Select the HTML heading tag for the title',
  },
  {
    name: 'title',
    type: 'string',
  },
  {
    name: 'body',
    type: 'richText',
  },
  {
    name: 'href',
    type: 'url',
  },
  {
    name: 'imageCard',
    type: 'boolean',
    defaultValue: false,
  },
  imageField('image'),
] as const satisfies DeepReadonly<Input[]>;

const textCardConfig = {
  name: 'textCard',
  inputs: textCardFields,
};

export type TextCardProps = GenerateBuilder<typeof textCardFields>;

export default textCardConfig;
